import { initI18n, getLocaleCookie, setLocaleCookie } from './i18n'

async function initLocale () {
  const language = navigator.language || navigator.userLanguage
  let locale = await getLocaleCookie()

  if (!locale) {
    if (language) {
      if (language.indexOf('ko') > -1) {
        locale = 'ko'
      } else if (language.indexOf('ja') > -1) {
        locale = 'ja'
      } else {
        locale = 'en'
      }
    } else {
      locale = 'en'
    }
    setLocaleCookie(locale)
  }

  document.documentElement.setAttribute('lang', locale)
  return locale
}

function loadWebFonts (locale) {
  return new Promise((resolve, reject) => {
    let webfont = 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600&family=Noto+Sans+KR:wght@400;500;600;700;800;900&family=Noto+Sans+JP'

    let link = document.createElement('link')
    link.setAttribute('rel', 'stylesheet')
    link.setAttribute('href', webfont)
    link.setAttribute('media', 'all')
    link.setAttribute('crossorigin', 'anonymous')

    let head = document.getElementsByTagName('head')[0]
    if (!head) {
      head = document.documentElement
    }
    head.insertBefore(link, head.lastChild)

    resolve()
  })
}

export default async function () {
  const locale = await initLocale()

  return loadWebFonts(locale).then(() => {
    return initI18n(locale)
  }).catch(err => {
    console.error(err)
  })
}
